import { render } from "./DashboardRight.vue?vue&type=template&id=45040725&scoped=true"
import script from "./DashboardRight.vue?vue&type=script&lang=js"
export * from "./DashboardRight.vue?vue&type=script&lang=js"

import "./DashboardRight.vue?vue&type=style&index=0&id=45040725&scoped=true&lang=css"

import exportComponent from "/vercel/path0/Source Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45040725"]])

export default __exports__